export default __webpack_public_path__ + "static/media/debitcard.64c4a947.png";